/**
 * Cutting a reply down to what the person actually typed.
 *
 * Deliberately the *only* mechanical step left on the inbound path: understanding the answer
 * is the model's job, since demanding a format from someone typing on a phone is how a channel
 * dies. But the quoting has to go first — the question mail is quoted back in full, examples
 * included, and a model handed that would answer its own questions.
 */

/** Lines from here on are the quoted original, not the answer. */
const QUOTE_MARKERS = [
  /^>/,
  /^-{2,}\s*(?:urspr[üu]ngliche nachricht|original message|weitergeleitete nachricht)/i,
  /^am\s.+\sschrieb\s.+:\s*$/i,
  /^on\s.+\swrote:\s*$/i,
  /^von:\s/i,
  /^from:\s/i,
  /^gesendet:\s/i,
  /^_{5,}\s*$/,
];

/** A signature is not an answer — everything after a `-- ` line is dropped. */
const SIGNATURE_MARKER = /^--\s*$/;

/**
 * Strip everything that is not what the person typed just now. Without this the quoted
 * question mail comes back with the reply, and its own "1: A" example would be read as an
 * answer the user never gave.
 */
export function stripQuotedText(body: string): string {
  const kept: string[] = [];
  for (const line of body.split(/\r?\n/)) {
    if (QUOTE_MARKERS.some(marker => marker.test(line.trim()))) break;
    if (SIGNATURE_MARKER.test(line)) break;
    kept.push(line);
  }
  return kept.join('\n').trim();
}
